module.exports = ".curpointer {\r\n  cursor:pointer;\r\n}\r\n"